export const SET_CHANGED_ITEM ='SET_CHANGED_ITEM';
export const DELETE_ITEM ='DELETE_ITEM';
export const DELETE_CHANGED_ITEMS = 'DELETE_CHANGED_ITEMS';
export const ADD_ITEM ='ADD_ITEM';
export const SET_ALL_ITEM = 'SET_ALL_ITEM';
export const SEND_ORDER = 'SEND_ORDER';


export function setChangedItem(id) {
    return{
        type: SET_CHANGED_ITEM,
        payload: id
    }
}
export function deleteItem(id) {
    return{
        type: DELETE_ITEM,
        payload: id
    }
}
export function addItem(element) {
    return{
        type: ADD_ITEM,
        payload: element
    }
}

export function setAllItem(flag) {
    return{
        type:SET_ALL_ITEM,
        payload: flag,
    }
}

export function deleteChangedItem() {
    return{
        type:DELETE_CHANGED_ITEMS,
    }
}
export function sendOrder() {
    return{
        type: SEND_ORDER,
    }
}
